import React from 'react';
import LaoOrderDetails from 'components/LAO/LaoOrderDetails';
import LAOVolumeChart from 'components/LAO/LaoVolumeChart';

const LaoHome = () => {
  return (
    <div>
        <LAOVolumeChart />
        <LaoOrderDetails />
    </div>
  )
}

export default LaoHome